import { uploadData } from "aws-amplify/storage";
import { Amplify } from "aws-amplify";
import config from "../config";

import logger from "../logger";

const { AudioURL, AudioBucket } = config;
const albumBucketName = AudioBucket;

async function UploadAudio(audio, filename, folder) {
  try {
    const fileName = `${filename}-${Date.now()}`;
    const audioKey = `${folder}/${fileName}`;

    Amplify.configure({
      ...Amplify.getConfig(),
      Storage: {
        S3: {
          region: process.env.REACT_APP_REGION,
          bucket: albumBucketName,
        },
      },
    });

    await uploadData({
      path: `${audioKey}`,
      data: audio,
      options: {
        contentType: "audio/mp3",
      },
    });

    const url = `${AudioURL}/${audioKey}`;
    return url;
  } catch (err) {
    logger.error(err);
  }
}

export async function UploadExerciseAudioAttempt(audio, filename) {
  const folder = "audioAttempt";

  const url = await UploadAudio(audio, filename, folder);
  return url;
}

export async function UploadPhraseAudio(audio, filename) {
  const folder = "phrases";
  if (!audio) {
    return alert("Please choose a file to upload first.");
  }
  const url = await UploadAudio(audio, filename, folder);
  return url;
}

export async function UploadRoleplayAudio(audio, filename) {
  const folder = "roleplays";
  const url = await UploadAudio(audio, filename, folder);
  return url;
}

export async function UploadBotsAudio(audio, filename) {
  const folder = "bots";
  const url = await UploadAudio(audio, filename, folder);
  return url;
}

export async function UploadReportProblemAudio(audio, filename) {
  const folder = "reportProblem";
  const url = await UploadAudio(audio, filename, folder);
  return url;
}
